import React from "react";
import moment from "moment/moment";
import { MENU_TYPE_ALL } from "../constants/app";
import { cloneDeep } from "lodash";

const useCustomDiscountOptions = ({ currentDate }) => {
  const data = window.store.getState().user.shopDiscounts;
  const [listDiscount, setListDiscount] = React.useState(null);

  React.useEffect(() => {
    if (currentDate) {
      fetchAllDiscount();
    }
  }, [currentDate, data]);

  const fetchAllDiscount = async () => {
    const discounts = cloneDeep(data);
    if (discounts?.length) {
      const availableDiscount = formatDiscount(discounts);
      if (availableDiscount?.length) {
        setListDiscount(availableDiscount);
      }
    }
  };

  const formatDiscount = (discounts) => {
    const dateFormatted = moment(currentDate).format("YYYY-MM-DD");
    const availableDiscount = discounts.filter((item) => {
      return (
        moment(item.valid_to).isAfter(dateFormatted) &&
        item.menu_type === MENU_TYPE_ALL
      );
    });
    return availableDiscount;
  };

  return { listDiscount };
};

export default useCustomDiscountOptions;
